module.exports = __webpack_public_path__ + "static/media/urenemasser.4956584d.svg";